export default interface IResponseModel<T> extends ApiException {
  exceptionType?: ExceptionType;
  content?: T;
}

// export class Messages {
//   title?: string;
//   severity: WebApiMessageSeverity = WebApiMessageSeverity.Error;
//   items?: string[];
//   detail?: string;
//   exceptionType?: ExceptionType = ExceptionType.System;
//   createdDT: Date = new Date();
//   messageId: number = -1;
// }

export function createApiException(
  description: string,

  detail?: string,
  exceptionReference?: string,
  status: number = 1,
  detailList: string[] = [],
  exceptionType: ExceptionType = ExceptionType.Business,
  severity: WebApiMessageSeverity = WebApiMessageSeverity.Error,
): ApiException {
  return {
    exceptionReference,
    description: description,
    detail,
    status,
    detailList,
    exceptionType,
    severity,
    type: "ApiException",
    traceId: "",
    instance: "",
  };
}
export interface ApiException {
  exceptionReference?: string;
  description?: string;
  detail?: string;
  status: number;
  detailList: string[];
  exceptionType?: ExceptionType;
  severity: WebApiMessageSeverity;
  type: string;
  traceId: string;
  instance: string;
}

export enum ExceptionType {
  System = "System",
  Business = "Business",
}

export enum WebApiMessageSeverity {
  Information = "Information",
  Warning = "Warning",
  Error = "Error",
}
